// Register GSAP plugin and set defaults
gsap.registerPlugin(ScrollTrigger);
gsap.defaults({ ease: "none", duration: 2 });


// Arrow animations
let arrow = document.querySelector('.arrow');
if (arrow) {
  gsap.to(arrow, { y: 12, ease: "power1.inOut", repeat: -1, yoyo: true, duration: 0.5 });
}

// Highlight text animations
document.addEventListener('DOMContentLoaded', function () {
  import('https://cdn.skypack.dev/split-type@0.3.3').then(({ default: SplitType }) => {
    const tlthick = gsap.timeline();
    const splitText = SplitType.create('h1.highlight-text, h2.highlight-text', { types: 'words' });
    const splitWords = splitText.words;

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Animate the highlight text
          tlthick.fromTo(".highlight-text", {
            opacity: 0,
          }, {
            opacity: 1,
            duration: 1,
            ease: 'linear'
          });

          splitWords.forEach((item, index) => {
            const width = item.offsetWidth;
            const dur = (width / 100) / 7;

            tlthick.fromTo(item, {
              backgroundPosition: "100%"
            }, {
              duration: dur,
              ease: 'linear',
              stagger: index * 0.1,
              backgroundPosition: "0"
            });
          });

          tlthick.fromTo(".rotate", {
            x: -500,
            opacity: 0
          }, {
            x: 0,
            opacity: 1,
            duration: 0.4,
            stagger: 0.3,
            ease: 'power3.out',
            delay: 1
          }, "-=1");

          tlthick.fromTo("p", {
            opacity: 0,
          }, {
            opacity: 1,
            duration: 1,
            ease: 'power1.out',
          });

          observer.unobserve(entry.target);
        }
      });
    });

    const highlightText = document.querySelector('.highlight-text');
    if (highlightText) {
      observer.observe(highlightText);
    }
  });
});
